/** Métrica secundária compacta. Padrão h-16, sem decoração. */
interface Props {
  label: string;
  value: string; // já formatado pelo caller
  hint?: string;
  tone?: "neutral" | "positive" | "negative";
}

export function MetricChip({ label, value, hint, tone = "neutral" }: Props) {
  const toneCls =
    tone === "positive"
      ? "text-indra-turquesa"
      : tone === "negative"
        ? "text-red-400"
        : "text-slate-100";
  return (
    <div
      className="h-16 px-3 py-2 border border-slate-700/40 rounded-md flex flex-col justify-center bg-indra-azul-surface"
      title={hint}
    >
      <div className="text-[10px] uppercase tracking-wide text-slate-400 font-medium">
        {label}
      </div>
      <div className={`text-base font-semibold whitespace-nowrap ${toneCls}`}>
        {value}
      </div>
    </div>
  );
}
